import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { MetricValues } from '@/modules/finances/types';
import { CellAnnually } from './cell-annually';
import { getKeyMetric } from './cell-semi-annually';
import { orderMetrics } from './header-semi-annually';

// Util functions - placed in same file per migration instructions
const defaultOrder = ['Budget', 'Forecast', 'Net Protocol Outflow', 'Net Expenses On-Chain', 'Actuals'];
function filterActiveMetrics(activeMetrics: string[], headerTable: MetricValues[]): Array<Partial<MetricValues>> {
  return headerTable.map(header => {
    const filteredMetrics: Partial<MetricValues> = {};
    activeMetrics.forEach(metric => {
      const matchKey = getKeyMetric(metric);
      if (matchKey in header) {
        filteredMetrics[matchKey as keyof MetricValues] = header[matchKey as keyof MetricValues];
      }
    });
    return filteredMetrics;
  });
}
interface HeaderAnnuallyProps {
  year: string;
  title: string;
  headerTable: MetricValues[];
  activeMetrics: string[];
}
function HeaderAnnually(t0) {
  const $ = _c(23);
  const {
    year,
    title,
    activeMetrics,
    headerTable
  } = t0;
  let t1;
  if ($[0] !== activeMetrics || $[1] !== headerTable) {
    t1 = filterActiveMetrics(activeMetrics, headerTable);
    $[0] = activeMetrics;
    $[1] = headerTable;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const metricsActive = t1;
  let t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("flex min-h-[83px] flex-1 items-center justify-start overflow-hidden rounded-xl whitespace-pre", "bg-muted shadow-sm", "[&::-webkit-scrollbar]:h-0 [&::-webkit-scrollbar]:w-0");
    t3 = cn("flex flex-1 flex-row items-center p-2 whitespace-break-spaces", "md:p-4 md:px-2", "xl:px-8 xl:py-4", "2xl:max-w-[1312px]");
    t4 = cn("flex w-[78px] min-w-[78px] items-center whitespace-break-spaces", "md:h-12 md:w-[140px]", "xl:w-[190px]", "2xl:w-[170px]", "3xl:w-[195px]");
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== title) {
    t5 = <div className={t4}><div className="text-foreground max-w-full pr-2 text-xs leading-normal font-bold wrap-break-word md:text-base xl:whitespace-normal">{title}</div></div>;
    $[6] = title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== year) {
    t6 = <div className="text-foreground mb-2 text-center text-sm leading-[22px] font-semibold lg:text-xl lg:leading-normal lg:tracking-[0.4px]">{year}</div>;
    $[8] = year;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== metricsActive[0]) {
    t7 = metricsActive[0] ?? {};
    $[10] = metricsActive[0];
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== activeMetrics) {
    t8 = orderMetrics(defaultOrder, activeMetrics);
    $[12] = activeMetrics;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <div className="flex w-full flex-row items-center justify-between"><CellAnnually metrics={t7} activeMetrics={t8} /></div>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t9) {
    t10 = <div className="flex flex-1 flex-col items-center">{t6}{t9}</div>;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5) {
    t11 = <div className={t2}><div className={t3}>{t5}{t10}</div></div>;
    $[20] = t10;
    $[21] = t5;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}
export { HeaderAnnually };